var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbA1CNonOptimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2331 21.3535C12.6584 20.4691 14.3024 20.0005 15.9799 20.0005C17.6572 20.0005 19.3013 20.4691 20.7266 21.3535",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 14.0007C24.7929 13.4156 24.4099 12.909 23.9033 12.5507C23.3967 12.1924 22.7915 12 22.1709 12C21.5504 12 20.9452 12.1924 20.4385 12.5507C19.9425 12.9015 19.5651 13.3945 19.3555 13.9641",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.0007C7.20669 13.4156 7.58972 12.909 8.09632 12.5507C8.60292 12.1924 9.20816 12 9.82867 12C10.4492 12 11.0544 12.1924 11.561 12.5507C12.0588 12.9028 12.4373 13.3981 12.6464 13.9704",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbA1CNonOptimal);
export default __webpack_public_path__ + "static/media/HbA1cNonOptimal.4923e92d912519b8d717a23c56ca1866.svg";
export { ForwardRef as ReactComponent };